import React from 'react';
import formatRands from 'functions/formatRands.func';
import { getTierLabel } from 'components/LoyaltyProgram/tiers';
import GetSvg from '../../vendor/GetSvg';
import { BENEFITS, getTierBenefits } from './benefits';

const getRequirement = (status, nextStatus, spendTarget, itemsTarget) => {
  const condition = status ? 'AND' : 'OR';
  const ending = nextStatus
    ? `to unlock ${getTierLabel(nextStatus)} benefits`
    : `to continue receiving ${getTierLabel(status)} benefits`;

  return `Spend over ${formatRands(
    spendTarget,
  )} ${condition} ${itemsTarget} items purchased (in a year) ${ending}`;
};

const Benefits = ({ loyaltyProgram }) => {
  const status = loyaltyProgram.loyalty_status;
  const earned = getTierBenefits(status);
  const heading = `${getTierLabel(status)} Benefits`;

  return (
    <div className="benefits">
      <div className="benefits__heading">{heading}</div>

      <p className="benefits__requirement">
        {getRequirement(
          status,
          loyaltyProgram.next_status,
          loyaltyProgram.spend.target,
          loyaltyProgram.items.target,
        )}
      </p>

      <ul className="benefits__list">
        {BENEFITS.map((benefit) => (
          <li
            className={`benefits__item${
              earned.includes(benefit.key) ? '' : ' benefits__item--locked'
            }`}
            key={benefit.key}>
            <GetSvg
              svg={`benefit_${benefit.key}`}
              wrapperClass="svg benefits__icon"
            />
            <span className="benefits__label">{benefit.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Benefits;
